export const numberFormat = (value: number) => {
  return new Intl.NumberFormat('en-IN').format(value)
}
